<template>
  <div>
    <span v-for="(count, index) in endpointTypeCount" :key="index">
      <span v-if="index === 'abgangsfelder' && count > 0" v-tooltip.top="'Abgangsfelder'">
        <i class="material-icons">flip_to_front</i> {{ count }}
      </span>
      <span v-if="index === 'trafostationen' && count > 0" v-tooltip.top="'Trafostationen'">
        <i class="material-icons">transform</i> {{ count }}
      </span>
      <span v-if="index === 'hausanschluesse' && count > 0" v-tooltip.top="'Hausanschlüsse'">
        <i class="material-icons">home</i>  {{ count }}
      </span>
    </span>
  </div>
</template>

<script>
export default {
  name: 'Stats',
  props: {
    endpoint: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      endpointTypeCount: [],
    };
  },
  created() {
    this.$store.dispatch('GET_ENDPOINT_COUNT_TYPES_BY_ID', this.endpoint).then((resp) => { this.endpointTypeCount = resp; });
  },
};
</script>
